const Style = {
    table: 'w-full border-separate -mb-6 mt-[-1.3em]',
    inputs: 'w-full -mb-6 mb-5 md:flex md:gap-2',
    search: 'flex mb-2 md:mb-0 flex-1 w-4/5',
    searchableDropdown: 'md:mb-0 w-1/5',
    searchableDropdownInput: 'border-slate-200 focus:bg-slate-50 appearance-none disabled:opacity-50',
}

export default Style;